const templatesNamesForTypes = {
  EMAIL: 'EmailTemplateId',
  PUSH: 'PushTemplateId',
  PHONE: 'PhoneTemplateId',
  SMS: 'SmsTemplateId',
}
export default templatesNamesForTypes;